<script>
    import { Router, Link, Route } from "svelte-routing";
    import List from "./list/list.html";
</script>

<Router>
    <Route path="">
        <List/>
    </Route>
    <Route path="/:bradCrumbLink" let:params>
        <List bradCrumbLink={params.bradCrumbLink}/>
    </Route>
</Router>